module.exports = __webpack_public_path__ + "img/G2.90b0e800.png";